'use strict'
import serviceBase from './serviceBase';

const QuoteOrder = {
    QuoteOrderBookingEmail:(data)=>serviceBase.post('/quoteOrderBooking',data),
    Questions:(data)=>serviceBase.post('/quoteOrderBooking/question',data),
    UpdateLinkMaster:(data)=>serviceBase.post(`/mysuiteamerica-quote/apis/UpdateLinkMaster&&OrderId=${data.OrderId}&MasterId=${data.MasterId}&QQUniqueId=${data.QQUniqueId}`),
}
export default QuoteOrder;